module.exports = __webpack_public_path__ + "img/floor_f10_02.5a4f5424.png";